<template>
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 9999;">
    <div 
      v-for="toast in toasts" 
      :key="toast.id"
      :class="['toast', 'show', `border-${toast.type}`]"
      role="alert" 
      aria-live="assertive" 
      aria-atomic="true"
    >
      <div :class="['toast-header', `bg-${toast.type}`, 'text-white']">
        <i :class="getIconClass(toast.type)" class="me-2"></i>
        <strong class="me-auto">{{ getTitle(toast.type) }}</strong>
        <button 
          type="button" 
          class="btn-close btn-close-white" 
          @click="removeToast(toast.id)"
          aria-label="Cerrar"
        ></button>
      </div>
      <div class="toast-body">
        {{ toast.message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToastContainer',
  props: {
    toasts: {
      type: Array,
      default: () => []
    }
  },
  emits: ['remove-toast'],
  methods: {
    getIconClass(type) {
      const icons = {
        success: 'fas fa-check-circle',
        error: 'fas fa-exclamation-circle',
        warning: 'fas fa-exclamation-triangle',
        info: 'fas fa-info-circle'
      }
      return icons[type] || icons.info
    },
    
    getTitle(type) {
      const titles = {
        success: 'Éxito',
        error: 'Error',
        warning: 'Advertencia',
        info: 'Información'
      }
      return titles[type] || titles.info
    },
    
    removeToast(id) {
      this.$emit('remove-toast', id)
    }
  }
}
</script>

<style scoped>
.toast {
  min-width: 300px;
  margin-bottom: var(--spacing-sm);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.toast-header {
  font-weight: 600;
}

.bg-success {
  background-color: #198754 !important;
}

.bg-error {
  background-color: #dc3545 !important;
}

.bg-warning {
  background-color: #ffc107 !important;
  color: #000 !important;
}

.bg-info {
  background-color: #0dcaf0 !important;
}

.border-success {
  border-left: 4px solid #198754 !important;
}

.border-error {
  border-left: 4px solid #dc3545 !important;
}

.border-warning {
  border-left: 4px solid #ffc107 !important;
}

.border-info {
  border-left: 4px solid #0dcaf0 !important;
}

/* Animaciones */
.toast {
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
